import { useState, useEffect } from 'react';
import { useNotificationProvider } from 'hooks';
import getCanTabApi from 'api/cantabs/getCanTabApi';
import convertStrAva from 'containers/cantabs/libs/convertStrAva';
import filterCanTabs from '../libs/filterCanTabs';
import { useSelector } from 'react-redux';
import { selectUserInfo } from 'redux/userInfo/userInfoSlice';

/**
 * @function useCantabs
 * @returns {UseCantabsState} The state containing menus and user data.
 */
function useCantabs() {
	const { notifyError } = useNotificationProvider();

	const { userInfo } = useSelector(selectUserInfo);

	const [menus, setMenus] = useState([]);
	const [user, setUser] = useState({});

	useEffect(() => {
		(async () => {
			if (userInfo.userId.trim() !== '') {
				try {
					const res = await getCanTabApi();
					const _menus = await filterCanTabs(res);
					const _strAva = convertStrAva(userInfo.fullname);
					setUser({
						id: String(userInfo.userId),
						contactId: String(userInfo.contactId),
						customerId: String(userInfo.customerId),
						username: String(userInfo.fullname),
						strAva: String(_strAva),
						vFile: String(userInfo.vFile),
						img: String(userInfo.image),
					});
					setMenus(_menus);
				} catch (error) {
					console.error('[useCantabs] Failed to load menu data:', error);
					notifyError('Could not load sidebar menu. Please try refreshing the page.');
				}
			}
		})();
	}, [notifyError, userInfo]);

	return { menus, user };
}

export default useCantabs;
